import React from 'react';

export const SuccessToast = () => {
	return(
		<div className="success_toast">
			Thanks for the email! I'll be in touch soon.
		</div>
	)
}